@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Connecticut</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[1].formControlName)?.touched &&
            reactiveForm.get(controls[1].formControlName)?.invalid,
          '_ml-large': baseRules?.Show_Indent,
        }"
      >
        @if (controls?.length >= 2) {
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }

        <div class="axis-grid">
          @for (control of controls | slice: 3; track $index) {
            @if (control.formControlName.startsWith("UISUIM_") && baseRules[control.baseRuleKey]?.includes("show")) {
              <div class="axis-col-sm-6 axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-required':
                      reactiveForm.get(control.formControlName)?.value === null ||
                      reactiveForm.get(control.formControlName)?.value === '',
                    'has-axis-error':
                      reactiveForm.get(control.formControlName)?.touched &&
                      reactiveForm.get(control.formControlName)?.invalid,
                    '_ml-large': baseRules?.Show_Indent,
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="{{ control.formControlName }}"
                    >{{ control.label }}
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    >
                  </label>
                  <axis-dropdown
                    [dataProvider]="control.data"
                    id="{{ control.formControlName }}"
                    formControlName="{{ control.formControlName }}"
                    (onSelect)="handleDropdownSelection(control, $event)"
                  ></axis-dropdown>
                  @if (reactiveForm.get(control.formControlName)?.touched) {
                    @if (reactiveForm.get(control.formControlName)?.invalid) {
                      <span
                        class="axis-error-block"
                        role="alert"
                        >Please select an option.</span
                      >
                    }
                  }
                  @if (control.selectedPremium) {
                    <div [hidden]="!showPremium">Premium: {{ control.selectedPremium }}</div>
                  }
                </div>
              </div>
            }
            @if (
              control.formControlName.startsWith("UISUIM_") && baseRules?.[control.baseRuleKey]?.includes("readonly")
            ) {
              <div class="axis-col-sm-6 axis-col-lg-4">
                <div class="axis-form-group">
                  <label class="axis-control-label">{{ control.label }}</label>
                  <div id="{{ dynamicLimitId[control.formControlName] }}-pdffield-connecticut">
                    {{ control.data[0].name }}
                  </div>
                </div>
              </div>
            }
          }
        </div>

        @if (controls?.length >= 3) {
          <axis-radio-button-wrapper
            formControlName="{{ controls[2].formControlName }}"
            [ngClass]="{
              'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
              'has-axis-error':
                reactiveForm.get(controls[2].formControlName)?.touched &&
                reactiveForm.get(controls[2].formControlName)?.invalid,
              '_ml-large': baseRules?.Show_Indent,
            }"
          >
            @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }

        <div class="axis-grid">
          @for (control of controls | slice: 5; track $index) {
            @if (control.formControlName.startsWith("UICUIM_") && baseRules[control.baseRuleKey]?.includes("show")) {
              <div class="axis-col-sm-6 axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-required':
                      reactiveForm.get(control.formControlName)?.value === null ||
                      reactiveForm.get(control.formControlName)?.value === '',
                    'has-axis-error':
                      reactiveForm.get(control.formControlName)?.touched &&
                      reactiveForm.get(control.formControlName)?.invalid,
                    '_ml-large': baseRules?.Show_Indent,
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="{{ control.formControlName }}"
                    >{{ control.label }}
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    >
                  </label>
                  <axis-dropdown
                    [dataProvider]="control.data"
                    id="{{ control.formControlName }}"
                    formControlName="{{ control.formControlName }}"
                    (onSelect)="handleDropdownSelection(control, $event)"
                  ></axis-dropdown>
                  @if (reactiveForm.get(control.formControlName)?.touched) {
                    @if (reactiveForm.get(control.formControlName)?.invalid) {
                      <span
                        class="axis-error-block"
                        role="alert"
                        >Please select an option.</span
                      >
                    }
                  }
                  @if (control.selectedPremium) {
                    <div [hidden]="!showPremium">Premium: {{ control.selectedPremium }}</div>
                  }
                </div>
              </div>
            }

            @if (
              control.formControlName.startsWith("UICUIM_") && baseRules?.[control.baseRuleKey]?.includes("readonly")
            ) {
              <div class="axis-col-sm-6 axis-col-lg-4">
                <div class="axis-form-group">
                  <label class="axis-control-label">{{ control.label }}</label>
                  <div id="{{ dynamicLimitId[control.formControlName] }}-pdffield-connecticut">
                    {{ control.data[0].name }}
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </form>
    <p>{{ textValues?.description }}</p>
    <p>{{ textValues?.Refer_Text }}</p>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Connecticut</h2>
  <!-- @if (baseRules?.SplitLimits_LevelTwo_UISUIM_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text }}
      </label>
      <div>{{ baseRules?.Reject_LevelOne_Radio }}</div>
    </div>
  } -->

  <div class="axis-grid">
    @if (baseRules?.UISUIM_CombinedSingleMinLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[8].label }} </label>
          <div>{{ controls[8].data[0].name }}</div>
        </div>
      </div>
    }
  </div>
}
